import request from '@/utils/request'
/**
 * @apiName 维保订单信息确认
 * @param  data {id:维保单id,exceedAmount:超保费,维保类型为保养时，必填，可为0
 * ,floatAmount:保险上浮费，维保类型为维修时，必填，可为0,
 * depreciationAmount:加速折旧费,维保类型为维修时，必填，可为0}
 */
export function maintenanceConfirmReceivableApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/confirmReceivable',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 维保订单发起支付
 * @param data  {id:维保单id}
 */
export function maintenancePayApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/pay',
    method: 'POST',
    data,
  })
}
